import Vue from 'vue'
import firebase from 'firebase';
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Request from '../views/request/index.vue'
import Guarantee from '../views/guarantee/index.vue'
import Company from '../views/company/index.vue'
import User from '../views/users/index.vue'
import RequestAdd from '../views/request/add.vue'
import Signature from '../views/signature/index.vue'
import store from '@/store/index'


Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: 'requests',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/requests',
    name: 'Request',
    component: Request,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/requests/add',
    name: 'RequestAdd',
    component: RequestAdd,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/requests/:id',
    name: 'RequestEdit',
    component: RequestAdd,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/signature',
    name: 'Signature',
    component: Signature,
    meta: {
      requiresAdmin: true,
      requiresAuth: true,
    }
  },
  {
    path: '/guarantee',
    name: 'Guarantee',
    component: Guarantee,
    meta: {
      requiresAdmin: true,
      requiresAuth: true,
    }
  },
  {
    path: '/users',
    name: 'User',
    component: User,
    meta: {
      requiresAdmin: true,
      requiresAuth: true,
    }
  },
  {
    path: '/companies',
    name: 'Company',
    component: Company,
    meta: {
      requiresAdmin: true,
      requiresAuth: true,
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  store.commit('loadingStart')
  setTimeout(() => {
    const currentUser = firebase.auth().currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth && !currentUser) {
      next('login');
    } else if (store.state.auth === null) {
      firebase.auth().signOut()
      next()
    } else {
      next()
    }
  },250)
});

router.afterEach((to) => {
  switch (to.name) {
    case 'RequestEdit':
      break
    default:
      setTimeout(() => {
        store.commit('loadingStop')
      },250)
  }
})

export default router
